import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-wallet-connect-dialog',
  templateUrl: './wallet-connect-dialog.component.html',
  styleUrls: ['./wallet-connect-dialog.component.scss']
})
export class WalletConnectDialogComponent implements OnInit {
  text:String="";
  network : String = environment.clientDetails.network;
  constructor(public dialogRef: MatDialogRef<WalletConnectDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
      this.text = data ? data?.text : '';
    }

  ngOnInit() {
  }

}
